/**
 * route.ts — where the public marketing-preferences page lives.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: marketing consent (2026-09-11).
 *
 * A CONSTANT, NOT A LITERAL, for the same reason as `safety/route.ts`: three
 * places must agree on this path — the route table, the tracking gate's
 * `RESERVED_SEGMENTS` (a single-segment path is otherwise read as a clinic slug
 * and loads GTM) and the link clinic-service puts in every marketing email
 * (`${PORTAL_BASE_URL}/preferences#t=<token>`). A segment list that disagrees
 * with the route table by one letter fails silently: the page still renders, it
 * just renders with ad-tech on it.
 *
 * ⚠️ The EMAIL side of this path is owned by clinic-service, not this file. If it
 * ever moves, the old path has to keep working (a redirect like the
 * clinical-safety misspelling), because links already sit in people's inboxes
 * and an unsubscribe must still work months later.
 */
export const PREFERENCES_PATH = '/preferences';
